import { render, staticRenderFns } from "./fwsed-dashboard.vue?vue&type=template&id=fc97802e&scoped=true&"
import script from "./fwsed-dashboard.vue?vue&type=script&lang=js&"
export * from "./fwsed-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./fwsed-dashboard.vue?vue&type=style&index=0&id=fc97802e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc97802e",
  null
  
)

export default component.exports